import { render, staticRenderFns } from "./App_v2.vue?vue&type=template&id=512ee3ee&"
import script from "./App_v2.vue?vue&type=script&lang=js&"
export * from "./App_v2.vue?vue&type=script&lang=js&"
import style0 from "./App_v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports